<div [ngSwitch]="type" class="h-full">
  <div *ngSwitchCase="'card'" class="w-4/5 h-full border-grisMedio1 bg-white rounded-md mx-auto mt-20">
    <div class="flex animate-pulse flex-row items-center h-full justify-center space-x-5">
      <div class="w-12 bg-grisMedio1 h-12 rounded-full"></div>
      <div class="flex flex-col space-y-3">
        <div class="w-36 bg-grisMedio1 h-4 rounded-md"></div>
        <div class="w-24 bg-grisMedio1 h-4 rounded-md"></div>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'text'" class="h-full bg-white flex rounded-sm">
    <div *ngFor="let line of lines" class="ml-6 w-{{ line }} bg-grisMedio1 h-4 rounded-md self-center animate-pulse"></div>
  </div>
  <div *ngSwitchCase="'calendar'">
    <div class="flex justify-between mb-5 ml-6 mr-3">
      <div class="w-56 bg-grisMedio1 h-4 rounded-md animate-pulse"></div>
      <div class="w-36 bg-grisMedio1 h-4 rounded-md animate-pulse"></div>
    </div>
    <div class="h-full bg-white flex rounded-sm">
      <div *ngFor="let line of lines" class="flex flex-col min-h10 max-h20 calendar__weekend rounded">
        <div class="w-{{ line }} bg-grisMedio1 h-4 rounded-md self-center mt-2.5 mb-2 animate-pulse"></div>
        <div class="calendar__day"></div>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'activity'" class="h-full rounded-sm">
    <div class="activity">
      <div class="activity__container">
        <div class="activity__title">
          <div class="ml-6 w-96 bg-grisMedio1 h-10 rounded-full self-center animate-pulse"></div>
        </div>
        <hr />
        <div class="flex h-14 mt-2 mb-2">
          <ng-container *ngFor="let i of [].constructor(5)">
            <div class="ml-6 w-10 h-10 bg-grisMedio1 rounded-md self-center animate-pulse"></div>
          </ng-container>
        </div>
        <hr />
        <div class="ml-6 w-36 bg-grisMedio1 h-4 mt-4 mb-4 rounded-md self-center animate-pulse"></div>
        <ng-container *ngFor="let i of [].constructor(6)">
          <div class="ml-6 w-160 bg-grisMedio1 h-4 mb-4 rounded-md self-center animate-pulse"></div>
        </ng-container>
        <div class="ml-6 w-80 bg-grisMedio1 h-4 mb-4 rounded-md self-center animate-pulse"></div>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'circular-progress'">
    <div class="card-progress">
      <div class="card-progress__title">
        <div class="w-40 bg-grisMedio1 h-4 mb-8 rounded-md self-center animate-pulse"></div>
        <div class="w-60 bg-grisMedio1 h-4 rounded-md self-center animate-pulse"></div>
      </div>
      <div class="card-progress__chart"></div>
    </div>
  </div>
  <div *ngSwitchCase="'role'">
    <div class="card-role">
      <div class="card-role__title">
        <div class="w-40 bg-grisMedio1 h-4 mb-8 rounded-md self-center animate-pulse"></div>
        <div class="w-60 bg-grisMedio1 h-4 rounded-md self-center animate-pulse"></div>
      </div>
      <div class="card-role__circle"></div>
    </div>
  </div>
  <div *ngSwitchCase="'rubric'">
    <div class="rubric">
      <ng-container *ngFor="let icon of rubricIcons">
        <div class="rubric__container">
          <svg-icon [key]="icon" class="rubric__icon"></svg-icon>
          <div class="rubric__info">
            <div class="w-28 bg-grisMedio1 h-4 mb-4 rounded-md animate-pulse"></div>
            <div class="w-24 bg-grisMedio1 h-4 rounded-md animate-pulse"></div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div *ngSwitchCase="'ludification'">
    <div class="ludification">
      <div class="w-40 bg-grisMedio1 h-4 mb-4 rounded-md animate-pulse"></div>
      <div class="w-44 bg-grisMedio1 h-4 rounded-md animate-pulse"></div>
    </div>
  </div>
  <div *ngSwitchCase="'resource'">
    <div class="w-full bg-grisMedio1 h-12 mb-4 rounded-md animate-pulse"></div>
    <div class="w-full bg-grisMedio1 h-12 mb-4 rounded-md animate-pulse"></div>
    <div class="w-full bg-grisMedio1 h-12 mb-4 rounded-md animate-pulse"></div>
  </div>
  <div *ngSwitchCase="'resources'">
    <div class="resources">
      <div class="w-60 bg-grisMedio1 h-8 mb-4 rounded-md animate-pulse"></div>
      <div class="w-full bg-grisMedio1 h-20 mb-4 rounded-md animate-pulse"></div>
      <div class="w-80 bg-grisMedio1 h-6 mb-4 rounded-md animate-pulse"></div>
      <div class="w-80 bg-grisMedio1 h-6 mb-4 ml-6 rounded-md animate-pulse"></div>
      <div class="w-80 bg-grisMedio1 h-6 mb-4 ml-6 rounded-md animate-pulse"></div>
      <div class="w-80 bg-grisMedio1 h-6 mb-4 rounded-md animate-pulse"></div>
      <div class="w-80 bg-grisMedio1 h-6 mb-4 ml-6 rounded-md animate-pulse"></div>
      <div class="w-80 bg-grisMedio1 h-6 mb-4 ml-6 rounded-md animate-pulse"></div>
    </div>
  </div>
  <div *ngSwitchCase="'content'">
    <div class="mx-auto">
      <div class="flex items-center justify-between mb-4">
        <div class="w-72 bg-grisMedio1 h-8 mb-4 rounded-md animate-pulse"></div>
      </div>
      <div class="w-60 bg-grisMedio1 h-8 mb-4 rounded-md animate-pulse"></div>
      <div class="flex gap-2">
        <div class="w-1/3 bg-grisMedio1 h-40 mb-4 rounded-md animate-pulse"></div>
        <div class="w-1/3 bg-grisMedio1 h-40 mb-4 rounded-md animate-pulse"></div>
        <div class="w-1/3 bg-grisMedio1 h-40 mb-4 rounded-md animate-pulse"></div>
      </div>

      <div class="w-60 bg-grisMedio1 h-8 mb-4 rounded-md animate-pulse"></div>
      <div class="flex gap-2">
        <div class="w-1/3 bg-grisMedio1 h-40 mb-4 rounded-md animate-pulse"></div>
        <div class="w-1/3 bg-grisMedio1 h-40 mb-4 rounded-md animate-pulse"></div>
        <div class="w-1/3 bg-grisMedio1 h-40 mb-4 rounded-md animate-pulse"></div>
      </div>
      <div class="w-60 bg-grisMedio1 h-8 mb-4 rounded-md animate-pulse"></div>
      <div class="flex gap-2">
        <div class="w-1/3 bg-grisMedio1 h-40 mb-4 rounded-md animate-pulse"></div>
        <div class="w-1/3 bg-grisMedio1 h-40 mb-4 rounded-md animate-pulse"></div>
        <div class="w-1/3 bg-grisMedio1 h-40 mb-4 rounded-md animate-pulse"></div>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'content-extra'">
    <div class="w-screen bg-grisMedio1 h-56 mt-8 rounded-md animate-pulse"></div>
  </div>
  <div *ngSwitchCase="'curriculum-dropdown'">
    <div class="col-span-1 mr-2">
      <div class="h-12 w-full bg-grisMedio1 mb-4 rounded-md animate-pulse"></div>
      <div class="h-48 w-full bg-grisMedio1 mb-4 rounded-md animate-pulse"></div>
    </div>
  </div>
  <div *ngSwitchCase="'sequence'">
    <div class="flex justify-center">
      <div class="flex flex-col">
        <div class="bg-grisMedio1 w-80 h-8 mb-8 rounded-md animate-pulse"></div>
        <div class="flex items-center justify-center gap-4">
          <div class="w-80 col-span-1 bg-grisMedio1 h-96 mb-4 rounded-md animate-pulse"></div>
          <div class="w-80 col-span-1 bg-grisMedio1 h-96 mb-4 rounded-md animate-pulse"></div>
          <div class="w-80 col-span-1 bg-grisMedio1 h-96 mb-4 rounded-md animate-pulse"></div>
        </div>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'mainSessions'">
    <div class="flex items-center justify-center gap-4">
      <div class="w-full col-span-1 bg-grisMedio1 h-20 mb-4 rounded-md animate-pulse"></div>
    </div>
    <div class="flex items-center justify-center gap-4">
      <div class="w-full col-span-1 bg-grisMedio1 h-20 mb-4 rounded-md animate-pulse"></div>
    </div>
    <div class="flex items-center justify-center gap-4">
      <div class="w-full col-span-1 bg-grisMedio1 h-20 mb-4 rounded-md animate-pulse"></div>
    </div>
    <div class="flex items-center justify-center gap-4">
      <div class="w-full col-span-1 bg-grisMedio1 h-20 mb-4 rounded-md animate-pulse"></div>
    </div>
  </div>
  <div *ngSwitchCase="'secondarySessions'">
    <div class="flex items-center justify-center gap-4">
      <div class="w-full col-span-1 bg-grisMedio1 h-20 mb-4 rounded-md animate-pulse"></div>
      <div class="w-full col-span-1 bg-grisMedio1 h-20 mb-4 rounded-md animate-pulse"></div>
    </div>
  </div>
  <div *ngSwitchCase="'header'">
    <div class="w-full bg-grisMedio1 h-20 mb-4 rounded-md animate-pulse"></div>
  </div>
  <div *ngSwitchCase="'groups'">
    <div class="bg-blanco h-auto shadow-md mt-4 flex flex-col p-4 pl-6">
      <div class="w-full bg-grisMedio1 h-20 mb-4 rounded-md animate-pulse"></div>
    </div>
  </div>
  <div *ngSwitchCase="'course'">
    <div class="flex">
      <div class="h-6 w-16 mr-3 mb-3 bg-grisMedio1 animate-pulse"></div>
      <div class="h-6 w-16 mr-3 mb-3 bg-grisMedio1 animate-pulse"></div>
      <div class="h-6 w-16 mr-3 mb-3 bg-grisMedio1 animate-pulse"></div>
    </div>
    <div class="w-full bg-grisMedio1 h-20 mb-4 rounded-md animate-pulse"></div>
  </div>
</div>
